import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { http } from "../../services/HttpInterceptor";
import { RouteComponentProps, Link, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { observable } from "mobx";
import Pagination from "react-js-pagination";
import InputForm from "../site/layout/InputForm";
import { drawSelects } from "../site/layout/common";

interface EditPackageProps extends RouteComponentProps {
  changeToggle(action?: boolean): void;
}

@observer
export default class EditPackage extends React.Component<EditPackageProps> {
  @observable private package: any;
  @observable private contracts: any[] = [];
  @observable private isLoaded = false;
  @observable private redirect = false;
  @observable private validationErrors: string[] = [];
  @observable private page = 1;
  @observable private itemsPerPage = 50;
  @observable private search = "";
  @observable private status = "";
  @observable private sectorial = "";
  private pageSizeOptions = [25, 50, 100, 200];
  @observable private activeOptions = [
    { id: "0", name: "No mostrar" },
    { id: "1", name: "Mostrar" },
  ];
  @observable private statusOptions = [
    { id: "Pendiente Instalacion", name: "Pendiente Instalacion" },
    { id: "Activo", name: "Activo" },
    { id: "Pendiente Desconexion", name: "Pendiente Desconexion" },
    { id: "Desconectado", name: "Desconectado" },
    { id: "Pendiente Conexion", name: "Pendiente Conexion" },
    { id: "Cerrado", name: "Cerrado" },
    { id: "Pendiente Retiro", name: "Pendiente Retiro" },
    { id: "Empleado", name: "Empleado" },
  ];

  componentDidMount() {
    this.props.changeToggle(true);
    this.init();
  }

  init = () => {
    const match = this.props.match;
    const id = (match as any).params.id;
    http
      .get(`/api/package/read/${id}`)
      .then((response) => {
        this.package = response.data;
        this.isLoaded = true;
      })
      .then(() => {
        return http.get(`/api/package/contracts/${id}`).then((response) => {
          this.contracts = response.data.response || [];
        });
      })
      .catch(() => {
        if (!this.isLoaded) {
          toast.error("Error cargando paquete");
        } else {
          toast.error("Error cargando contratos del paquete");
        }
      });
  };

  private handleChange = (event: any) => {
    const { name, value } = event.target;
    this.package[name] = value;
  };

  private onSearchChange = (event: any): void => {
    this.search = event.target.value;
    this.page = 1;
  };

  private onFilterChange = (event: any): void => {
    const { name, value } = event.target;
    if (name === "status") {
      this.status = value;
    } else if (name === "sectorial") {
      this.sectorial = value;
    }
    this.page = 1;
  };

  private resetFilters = (): void => {
    this.search = "";
    this.status = "";
    this.sectorial = "";
    this.page = 1;
  };

  private getSectorialOptions = (): any[] => {
    const names = Array.from(
      new Set(
        this.contracts
          .map((contract) => contract.sectorial)
          .filter((name: string) => !!name)
      )
    ).sort();
    return names.map((name) => ({ id: name, name }));
  };

  private getFilteredContracts = (): any[] => {
    const keyword = this.search.trim().toLowerCase();
    return this.contracts.filter((contract) => {
      if (this.status && contract.status !== this.status) {
        return false;
      }
      if (this.sectorial && contract.sectorial !== this.sectorial) {
        return false;
      }
      if (!keyword) {
        return true;
      }
      const haystack = [
        contract.id,
        contract.client,
        contract.status,
        contract.sectorial,
        contract.ip,
      ]
        .join(" ")
        .toLowerCase();
      return haystack.includes(keyword);
    });
  };

  private getPaginatedContracts = (filtered: any[]): any[] => {
    const start = (this.page - 1) * this.itemsPerPage;
    return filtered.slice(start, start + this.itemsPerPage);
  };

  private changePage = (page: number): void => {
    this.page = page;
  };

  private changePageSize = (event: any): void => {
    this.itemsPerPage = Number(event.target.value);
    this.page = 1;
  };

  private goToContract = (id: number): void => {
    this.props.history.push(`/contratos/ver/${id}`);
  };

  private hasActiveFilters = (): boolean => {
    return !!(this.search || this.status || this.sectorial);
  };

  private setValidation = (value: boolean, name: string): void => {
    const error = this.validationErrors.indexOf(name);
    if (value && error === -1) {
      this.validationErrors.push(name);
    } else if (!value && error !== -1) {
      this.validationErrors.splice(error, 1);
    }
  };

  private onSubmit = (): void => {
    if (this.validationErrors.length > 0) {
      toast.error("Hay un error en tu formulario");
      return;
    }

    this.package.cost = this.package.cost.replace("$", "").replace(/,/g, "");
    this.package.speed = isNaN(this.package.speed)
      ? this.package.speed.replace("mb", "")
      : this.package.speed;

    http
      .post(`/api/package/update`, JSON.stringify(this.package))
      .then(() => {
        toast.success(`Paquete actualizado`);
        this.redirect = true;
      })
      .catch((error) => {
        if (Array.isArray(error)) {
          error.forEach((val) => {
            toast.error(val);
          });
        } else {
          toast.error(error);
        }
      });
  };

  render() {
    if (!this.isLoaded) {
      return null;
    }

    if (this.redirect) {
      return <Redirect to="/paquetes" />;
    }

    const filteredContracts = this.getFilteredContracts();
    const paginatedContracts = this.getPaginatedContracts(filteredContracts);
    const hasFilters = this.hasActiveFilters();

    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header card-header-rose card-header-text">
                <div className="card-text">
                  <h4 className="card-title">Paquete: {this.package.name}</h4>
                </div>
              </div>
              <div className="card-body ">
                <div className="row">
                  <div className="col-sm-10"></div>
                  <div className="col-sm-2">
                    <Link to={`../paquetes`}>
                      <button className="btn btn-danger btn-sm  pull-right">
                        <i className="material-icons">highlight_off</i>
                        <div className="ripple-container"></div>
                      </button>
                    </Link>
                  </div>
                </div>
                <InputForm
                  name="name"
                  label="Nombre"
                  value={this.package.name}
                  setValidation={this.setValidation}
                  required={true}
                  onChange={this.handleChange}
                  type="text"
                />
                <InputForm
                  name="speed"
                  label="Velocidad"
                  value={this.package.speed}
                  setValidation={this.setValidation}
                  required={true}
                  onChange={this.handleChange}
                  type="number"
                  decimal={0}
                  suffix="mb"
                />
                <InputForm
                  name="cost"
                  label="Costo"
                  value={this.package.cost}
                  setValidation={this.setValidation}
                  required={true}
                  onChange={this.handleChange}
                  type="number"
                  prefix="$"
                  decimal={2}
                />
                <InputForm
                  name="display"
                  label="Mostrar en pagina"
                  value={this.package.display.toString()}
                  setValidation={this.setValidation}
                  required={true}
                  onChange={this.handleChange}
                  type="select"
                  options={this.activeOptions}
                />
                <div className="row">
                  <label className="col-sm-2">Creado por</label>
                  <div className="col-sm-10">
                    <strong>{this.package.created_by_name}</strong>
                  </div>
                </div>
                <button
                  onClick={this.onSubmit}
                  type="submit"
                  className="btn btn-primary pull-right"
                >
                  Actualizar Paquete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header card-header-rose card-header-text">
                <div className="card-text">
                  <h4 className="card-title">
                    Contratos en este paquete ({filteredContracts.length}
                    {hasFilters ? ` de ${this.contracts.length}` : ""})
                  </h4>
                </div>
              </div>
              <div className="card-body ">
                {hasFilters && (
                  <div className="row" style={{ marginBottom: 10 }}>
                    <div className="col-sm-12">
                      <span className="pull-right">
                        Se encontraron {filteredContracts.length} resultados
                        <button
                          onClick={this.resetFilters}
                          style={{
                            height: 17,
                            width: 9,
                            padding: 10,
                            marginLeft: 10,
                          }}
                          type="button"
                          className="btn btn-danger"
                        >
                          <i
                            style={{ top: -9, right: 9 }}
                            className="material-icons"
                          >
                            close
                          </i>
                        </button>
                      </span>
                    </div>
                  </div>
                )}
                {this.contracts.length > 0 && (
                  <div className="row" style={{ marginBottom: 15 }}>
                    <div className="col-sm-12 text-right">
                      <label style={{ marginRight: 8 }}>Mostrar</label>
                      <select
                        className="form-control"
                        style={{ display: "inline-block", width: "auto" }}
                        value={this.itemsPerPage}
                        onChange={this.changePageSize}
                      >
                        {this.pageSizeOptions.map((size) => (
                          <option key={size} value={size}>
                            {size}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
                {filteredContracts.length > this.itemsPerPage && (
                  <div
                    className="row"
                    style={{
                      marginBottom: 15,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination
                      activePage={this.page}
                      itemsCountPerPage={this.itemsPerPage}
                      totalItemsCount={filteredContracts.length}
                      pageRangeDisplayed={5}
                      onChange={this.changePage}
                      activeClass="btn-warning"
                      itemClass="btn btn-round btn-info"
                      innerClass="btn-group paginador"
                      disabledClass="deshabilitado"
                    />
                  </div>
                )}
                <div className="table-responsive">
                  <table className="table">
                    <thead className=" text-primary">
                      <tr>
                        <th colSpan={2}>
                          <div className="form-group bmd-form-group is-filled">
                            <input
                              type="text"
                              name="search"
                              autoComplete="off"
                              placeholder="Buscar..."
                              onChange={this.onSearchChange}
                              className="form-control"
                              value={this.search}
                            />
                          </div>
                        </th>
                        <th>
                          {drawSelects(
                            this.statusOptions,
                            this.onFilterChange,
                            this.status,
                            "Estatus",
                            "status"
                          )}
                        </th>
                        <th>
                          {drawSelects(
                            this.getSectorialOptions(),
                            this.onFilterChange,
                            this.sectorial,
                            "Sectorial",
                            "sectorial"
                          )}
                        </th>
                        <th></th>
                      </tr>
                      <tr>
                        <th>ID</th>
                        <th>Cliente</th>
                        <th>Estado</th>
                        <th>Sectorial</th>
                        <th>IP</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.contracts.length === 0 && (
                        <tr>
                          <td colSpan={5}>No hay contratos con este paquete</td>
                        </tr>
                      )}
                      {this.contracts.length > 0 &&
                        filteredContracts.length === 0 && (
                          <tr>
                            <td colSpan={5}>
                              No se encontraron contratos con esos filtros
                            </td>
                          </tr>
                        )}
                      {paginatedContracts.map((contract: any) => (
                        <tr
                          key={contract.id}
                          onClick={() => this.goToContract(contract.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{contract.id}</td>
                          <td>{contract.client}</td>
                          <td>{contract.status}</td>
                          <td>{contract.sectorial}</td>
                          <td>{contract.ip}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {filteredContracts.length > this.itemsPerPage && (
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Pagination
                      activePage={this.page}
                      itemsCountPerPage={this.itemsPerPage}
                      totalItemsCount={filteredContracts.length}
                      pageRangeDisplayed={5}
                      onChange={this.changePage}
                      activeClass="btn-warning"
                      itemClass="btn btn-round btn-info"
                      innerClass="btn-group paginador"
                      disabledClass="deshabilitado"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
